function errorLog(serviceCode, errorMessage) {
  let finalErrorMsg = errorMessage;
  switch (serviceCode) {
    case 101:
      finalErrorMsg = `${MSG_101}`
    break;
    case 102:
      finalErrorMsg = `${MSG_102}`
    break;
    case 103:
      finalErrorMsg = `${MSG_103}`
    break;
    case 104:
      finalErrorMsg = `${MSG_104}`
    break;
    case 105:
      finalErrorMsg = `${MSG_105}`
    break;
    case 106:
      finalErrorMsg = `${MSG_106}`
    break;
    case 107:
      finalErrorMsg = `${MSG_107}`
    break;
    case 108:
      finalErrorMsg = `${MSG_108}`
    break;
    case 109:
      finalErrorMsg = `${MSG_109}`
    break;
    case 110:
      finalErrorMsg = `${MSG_110}`
    break;
    case 111:
      finalErrorMsg = `${MSG_111}`
    break;
    case 112:
      finalErrorMsg = `${MSG_112}`
    break;
    case 113:
      finalErrorMsg = `${MSG_113}`
    break;
    case 114:
      finalErrorMsg = `${MSG_114}`
    break;
    case 115:
      finalErrorMsg = `${MSG_115}`
    break;
    case 116:
      finalErrorMsg = `${MSG_116}`
    break;
    case 117:
      finalErrorMsg = `${MSG_117}`
    break;
    case 118:
      finalErrorMsg = `${MSG_118}`
    break;
    case 119:
      finalErrorMsg = `${MSG_119}`
    break;
    case 120:
      finalErrorMsg = `${MSG_120}`
    break;
    case 121:
      finalErrorMsg = `${MSG_121}`
    break;
    case 122:
      finalErrorMsg = `${MSG_122}`
    break;
    case 123:
      finalErrorMsg = `${MSG_123}`
    break;
    case 50005:
      finalErrorMsg = `${MSG_50005}`
    break;
    case 50008:
      finalErrorMsg = `${MSG_50008}`
    break;
    case 50012:
      finalErrorMsg = `${MSG_50012}`
    break;
    case 50014:
      finalErrorMsg = `${MSG_50014}`
    break;
    case 50015:
      finalErrorMsg = `${MSG_50015}`
    break;
    case 50016:
      finalErrorMsg = `${MSG_50016}`
    break;
    case 50018:
      finalErrorMsg = `${MSG_50018}`
    break;
    case 50019:
      finalErrorMsg = `${MSG_50019}`
    break;
    case 500:
      finalErrorMsg = `${MSG_500}`
    break;
  }
  return finalErrorMsg;
}

// email/code value from url
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// email validation
function ValidateEmail(email) {
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
  return (true)
 }
  return (false)
}

// Password validation
function ValidatePassword(password) {
  var decimal=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,25}$/;
  if(password.match(decimal)) {
    return true;
  } else {
    return false;
  }
}

// Name validation
function ValidateName(name) {
  if(/^[a-zA-Z0-9ÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ\s-,.\']+$/.test(name)) {
    return true;
  } else {
    return false;
  }
}

// mobile number validation
function Validatephonenumber(number) {
  var phoneno = /^\d{10}$/;
  if (number.match(phoneno)) {
    return true;
  }
    return false;
}

function formatPhoneNumber(str) {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  };

  return null
};

function cleanPhoneNumber(str) {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');
  return cleaned
};

// cookie function
function getCookie(name) {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

// JWT function
function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

// START Retry Verify Link fetch call uses in two places
function retryVerifyLink(email) {
  return new Promise(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const data = {
      email: email
    }
    var requestOptions = {
      method: "POST",
      mode: 'cors',
      headers: myHeaders,
      body: JSON.stringify(data)
    }
    fetch(`${AUTH_API}/globalauth/api/v1/auth/signup/confirm/resend`, requestOptions)
    .then((response) => response.json())
    .then((response) => {
      // if error is present
      if(response.error || response.statusCode) {
        let errCode = '';
        let errMsg = '';
        if (response.error) {
          if (response.statusCode) {
            errCode = response.statusCode;
            errMsg = response.message;
            if (errMsg == "User is already confirmed.") {
              window.location.href = `/account/login?accountconfirm=${data.email}`;
              return;
            }
          } else {
            errCode = response.error.serviceCode;
            errMsg = response.error.message;
          }
        }
        let finalErrorMsg = errorLog(errCode, errMsg);
        document.querySelector("#error").innerHTML = finalErrorMsg;
        document.querySelector('.error-message').classList.remove("hidden")
        return;
      } else {
        // if response is 200
        document.querySelector("#success").innerHTML = errorLog(104, "") + data.email;
        document.querySelector('.error-message').classList.add("hidden")
        document.querySelector('.success-message').classList.remove("hidden")
      }
    })
    .catch((e) => {
      console.error(e);
    });
  })
}
// END Retry Verify Link fetch call uses in two places

// START Retry Verify Link fetch call uses in two places
function loginCall(email, password) {
  return new Promise(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let data = {
      email: email,
      password: password,
    };
    var requestOptions = {
      method: "POST",
      mode: 'cors',
      headers: myHeaders,
      body: JSON.stringify(data)
    }
    fetch(`${AUTH_API}/globalauth/api/v1/auth/login`, requestOptions)
    .then((response) => response.json())
    .then((response) => {
      // if error is present
      if(response.error || response.statusCode) {
        let errCode = '';
        let errMsg = '';
        if (response.error) {
          if (response.error.serviceCode == "50020") {
            let response =  retryVerifyLink(email);
            response.then(email)
            let redirectURL = "/account/register?verifyemail&emailverification="+email;
            window.location.href = redirectURL;
            return;
          }
          if (response.statusCode) {
            errCode = response.statusCode;
            errMsg = response.message;
          } else {
            errCode = response.error.serviceCode;
            errMsg = response.error.message;
          }
        }
        let finalErrorMsg = errorLog(errCode, errMsg);
        document.querySelector("#loading").classList.add("hidden")
        document.querySelector("#error").innerHTML = finalErrorMsg;
        document.querySelectorAll('.login-form, .title-form, .error-message').forEach(item => {
          item.classList.remove("hidden")
        })
        return;
      } else {
        // if response is 200
        let date = new Date();
        date.setTime(date.getTime() + 400*36000);
        let expires = date.toUTCString();
        document.cookie = `accessToken=${response.AccessToken};expires=${expires};path=/;`;
        document.cookie = `IdToken=${response.IdToken};expires=${expires};path=/;`;
        window.location.href = "/pages/accounts"
      }
    })
    .catch((e) => {
      console.error(e);
      document.querySelector("#loading").classList.add("hidden")
      document.querySelector("#error").innerHTML = errorLog(500, "");
      document.querySelectorAll('.login-form, .title-form, .error-message, .success-message').forEach(item => {
        item.classList.remove("hidden")
      })
    });
  })
}
// END Retry Verify Link fetch call uses in two places

// This is used for user icon in header menu

setInterval(() => {
  const accessToken = getCookie('accessToken');
  if (accessToken && document.querySelector('.customer-header-menu') != null) {
    document.querySelector('.customer-header-menu').classList.add("hidden");
    document.querySelector('.sign-in-header-menu').classList.remove("hidden");
  }
}, 1000);


// START Update Profile
function updateProfile(data, type) {
  return new Promise(() => {
    const accessToken = getCookie('accessToken');
    if (accessToken) {
      const idToken = getCookie('IdToken');
      if (idToken) {
        const parseIdToken = parseJwt(idToken);
        if (parseIdToken) {
          var countryCode = parseIdToken["custom:country_code"]
        }
      }
      let userEndPoint = `${US_USER_API}`
      if (countryCode != null && countryCode != "" && countryCode != "US") {
        userEndPoint = `${INTL_USER_API}`
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", accessToken);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "PUT",
        mode: 'cors',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      }
      fetch(`${userEndPoint}/globaluser/api/v1/user`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        // if error is present
        if(response.error || response.statusCode) {
          let errCode = '';
          let errMsg = '';
          if (response.error) {
            if (response.statusCode) {
              errCode = response.statusCode;
              errMsg = response.message;
            } else {
              errCode = response.error.serviceCode;
              errMsg = response.error.message;
            }
          }
          let finalErrorMsg = errorLog(errCode, errMsg);
          document.querySelector("#error").innerHTML = finalErrorMsg;
          document.querySelector('.error-message').classList.remove("hidden")
          return;
        } else {
          // if response is 200
          response = response.updatedValues
          document.querySelector("#Account-Name").innerText = response.first_name + " " + response.last_name;
          document.querySelector("#Full-Name").innerText = response.first_name + " " + response.last_name;
          document.querySelector("#First-Name").innerText = response.first_name;
          document.querySelector("#Last-Name").innerText = response.last_name;
          document.querySelector("#AccountForm-FirstName").value = response.first_name;
          document.querySelector("#AccountForm-LastName").value = response.last_name;
          document.querySelector("#Email").innerText = data.email;
          document.querySelector("#Mobile-Number").innerText = formatPhoneNumber(response.phone_number);
          document.querySelector("#AccountForm-phone-number").value = formatPhoneNumber(response.phone_number);
          if (type == "mobileForm") {
            document.querySelector("#Setting-Mobile-Number #success").innerHTML = errorLog(114, "");
            document.querySelector("#Setting-Mobile-Number .success-message").classList.remove("hidden");
          } else {
            document.querySelector("#Setting-Name #success").innerHTML = errorLog(112, "");
            document.querySelector("#Setting-Name .success-message").classList.remove("hidden");
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
    } else {
      window.location.href = "/account/login?session";
    }

  })
}
// END Update Profile

// This condition is a flag for account deatils page if user clicked on account details in hamburger
if (window.location.href.indexOf("pages/accounts?account-details") > -1) {
  document.getElementById("account-details").checked = true;
}

// Get selling history in UI
if (window.location.href.indexOf("pages/accounts") > -1) {
  const idToken = getCookie('IdToken');
  if (idToken) {
    document.querySelector("#loading").classList.remove("hidden");
    var myHeaders = new Headers();

    myHeaders.append("Authorization", idToken);
    myHeaders.append("x-country-code", `${LOCALE}`);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    }

    let fetchEndpoint = `${US_USER_API}/globaluser/api/v1/user/dropoffcode`;
    if (USE_NEW_US_USER_API) {
      fetchEndpoint = US_USER_API_NEW
    }
    fetch(fetchEndpoint, requestOptions)
    .then((response) => {
      if(response.status  == 401) {
        document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "IdToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = "/account/login?session";
      } else {
      return  response.json()}
    })
    .then((response) => {
      // if error is present
      if(response.error || response.statusCode) {
        let errCode = '';
        let errMsg = '';
        if (response.error) {
          if (response.statusCode) {
            errCode = response.statusCode;
            errMsg = response.message;
          } else {
            errCode = response.error.serviceCode;
            errMsg = response.error.message;
          }
        }
        let finalErrorMsg = errorLog(errCode, errMsg);
        document.querySelector("#error").innerHTML = finalErrorMsg;
        document.querySelector("#SellingEmpty").classList.remove("hidden")
        document.querySelector("#loading").classList.add("hidden")
        return;
      } else {
        // if response is 200
        if (USE_NEW_US_USER_API) {
          response = response.dropOffCodes;
          if (response.length > 0) {
            var wrapper = document.getElementById("HtmlWrapper");
            var myHTML = "";
            var deviceImg = `${GENERIC_IMG}`;

            for (let i =0; i < response.length; i++) {
              // color status sold is green
              // color status expired is grey
              // color status new is blue, blue indicates expire to before 1 day
              // color status expiring is orange, orange indicates to 1 day before of expiration date

              if (response[i]['status'] == "REDEEMED") {
                response[i]['colorStatus'] = "sold";
                response[i]['expireText'] = errorLog(116, "");
                response[i]['dropOffDate'] = errorLog(116, "");
                response[i]['subText'] = "";
              } else if (response[i]['status'] == "ISSUED") {
                response[i]['colorStatus']='new';
                response[i]['expireText'] = errorLog(118, "");
                response[i]['subText'] = errorLog(121, "");
                response[i]['dropOffDate'] = new Date(response[i]['expirationDate']).toLocaleString('en-US', {  day: 'numeric', month: 'long', year: 'numeric'});
              } else if (response[i]['status'] == "EXPIRED"){
                response[i]['colorStatus'] = 'expired';
                response[i]['expireText'] = errorLog(117, "");
                response[i]['subText'] = errorLog(121, "");
                response[i]['dropOffDate'] = new Date(response[i]['expirationDate']).toLocaleString('en-US', {  day: 'numeric', month: 'long', year: 'numeric'});
              } else {
                response[i]['colorStatus'] = 'expiring';
                response[i]['expireText'] = errorLog(119, "");
                response[i]['dropOffDate'] = errorLog(120, "");
                response[i]['subText'] = errorLog(121, "");
              }
            }

            for (let i =0; i < response.length; i++) {
              deviceImg = `${GENERIC_IMG}`;

              if (response[i]['brand'] == "Apple") {
                deviceImg = `${APPLE_IMG}`;
              } else if (response[i]['brand'] == "Samsung") {
                deviceImg = `${SAMSUNG_IMG}`;
              }

              myHTML += `<div class="card grid grid--center grid--1-col grid--4-col-desktop ${response[i]['colorStatus']}" id="Color-Status">
              <div class="grid__item center">
                <p class="dropoff-label small-hide">Here's your dropoff code</p>
                <h2 class="h1 dropoff-code" id="Dropoff-Code">${response[i]['code'].toUpperCase()}</h2>
              </div>
              <div class="grid__item center device-details">
                <div class="device-image medium-up-hide">
                  <img src="${deviceImg}" loading="lazy">
                </div>
                <div class="device-specs">
                  <strong id="Manufacturer">${response[i]['brand']}</strong><br/>
                  <span id="Model">${response[i]['model']}</span><br/>
                  <span id="Capacity">${response[i]['capacity']}</span> <span id="Carrier">${response[i]['carrier']}</span>
                </div>
              </div>
              <div class="grid__item center">
                <h2 class="h1 dropoff-price" id="Dropoff-Price"><span>$</span>${response[i]['price']}${response[i]['expireText'] != errorLog(116, "") ? '*': ''}</h2>
                <p class="subtitle--small small-hide" id="Dropoff-Price-Sub-Text">${response[i]['subText']}</p>
              </div>
              <div class="grid__item center">
                ${response[i]['expireText'] != errorLog(116, "") ? `<strong class="expires-txt" id="Expires">${response[i]['expireText']}</strong><br/>`: ''}
                <h2 class="dropoff-date" id="Dropoff-Date">${response[i]['dropOffDate']}</h2>
                <p class="subtitle--small medium-up-hide" id="Dropoff-Price-Sub-Text">${response[i]['subText']}</p>
              </div>
              </div>`
            }
            wrapper.innerHTML = myHTML;
            document.querySelector("#loading").classList.add("hidden")
          } else {
            document.querySelector("#SellingEmpty").classList.remove("hidden")
            document.querySelector("#loading").classList.add("hidden")
            return;
          }
        } else {
          if (response.length > 0) {
            var wrapper = document.getElementById("HtmlWrapper");
            var myHTML = "";
            var deviceImg = `${GENERIC_IMG}`;
            for (let i =0; i < response.length; i++) {
              if (response[i]['ExpirationDate'] != undefined && response[i]['ExpirationDate'] != "" && response[i]['ExpirationDate'] != null) {
                response[i]['ExpirationDate'] = /\/Date\((.*)-.*\)\//.exec(response[i]['ExpirationDate'])[1];
              }
              if (response[i]['CreationDate'] != undefined && response[i]['CreationDate'] != "" && response[i]['CreationDate'] != null) {
                response[i]['CreationDate'] = /\/Date\((.*)-.*\)\//.exec(response[i]['CreationDate'])[1];
              }
              // color status sold is green, green indicates if DropOffTransactionId is present it's SOLD
              // color status expired is grey, grey indicates expired
              // color status new is blue, blue indicates expire to before 1 day
              // color status expiring is orange, orange indicates to 1 day before of expiration date
              let expiredDate = new Date(parseInt(response[i]['ExpirationDate'])).getTime();
              let now = Date.now();
              let dateDiff = 0;
              if(expiredDate != now) {
                dateDiff = ((now - expiredDate) / (1000 * 3600 * 24));
                if(dateDiff > 0) {
                  dateDiff = Math.ceil(dateDiff);
                } else {
                  dateDiff = Math.floor(dateDiff);
                }
              }
              if (response[i]['DropOffTransactionId'] != undefined && response[i]['DropOffTransactionId'] != "" && response[i]['DropOffTransactionId'] != null && response[i]['DropOffTransactionId'] != "00000000-0000-0000-0000-000000000000") {
                response[i]['colorStatus'] = "sold";
                response[i]['expireText'] = errorLog(116, "");
                response[i]['dropOffDate'] = errorLog(116, "");
                response[i]['subText'] = "";
              } else if (response[i]['ExpirationDate'] && new Date(parseInt(response[i]['ExpirationDate'])).toLocaleDateString('en-US') == new Date().toLocaleDateString('en-US')) {
                response[i]['colorStatus'] = 'expiring';
                response[i]['expireText'] = errorLog(119, "");
                response[i]['dropOffDate'] = errorLog(120, "");
                response[i]['subText'] = errorLog(121, "");
              } else if (response[i]['ExpirationDate'] && dateDiff > 0){
                response[i]['colorStatus'] = 'expired';
                response[i]['expireText'] = errorLog(117, "");
                response[i]['subText'] = errorLog(121, "");
                response[i]['dropOffDate'] = new Date(parseInt(response[i]['ExpirationDate'])).toLocaleString('en-US', {  day: 'numeric', month: 'long', year: 'numeric'});
              } else if (response[i]['ExpirationDate'] && dateDiff < 0) {
                response[i]['colorStatus']='new';
                response[i]['expireText'] = errorLog(118, "");
                response[i]['subText'] = errorLog(121, "");
                response[i]['dropOffDate'] = new Date(parseInt(response[i]['ExpirationDate'])).toLocaleString('en-US', {  day: 'numeric', month: 'long', year: 'numeric'});
              }
            }
            response = response.sort((a,b) => parseInt(b.ExpirationDate) - parseInt(a.ExpirationDate));
            response = response.sort((a,b) => (a.DropOffTransactionId  > b.DropOffTransactionId)? 1 : (a.DropOffTransactionId  < b.DropOffTransactionId) ? -1: 0);
            for (let i =0; i < response.length; i++) {
              deviceImg = `${GENERIC_IMG}`;

              if (response[i]['Manufacturer'] == "Apple") {
                deviceImg = `${APPLE_IMG}`;
              } else if (response[i]['Manufacturer'] == "Samsung") {
                deviceImg = `${SAMSUNG_IMG}`;
              }

              myHTML += `<div class="card grid grid--center grid--1-col grid--4-col-desktop ${response[i]['colorStatus']}" id="Color-Status">
              <div class="grid__item center">
                <p class="dropoff-label small-hide">Here's your dropoff code</p>
                <h2 class="h1 dropoff-code" id="Dropoff-Code">${response[i]['DropOffCode'].toUpperCase()}</h2>
              </div>
              <div class="grid__item center device-details">
                <div class="device-image medium-up-hide">
                  <img src="${deviceImg}" loading="lazy">
                </div>
                <div class="device-specs">
                  <strong id="Manufacturer">${response[i]['Manufacturer']}</strong><br/>
                  <span id="Model">${response[i]['Model']}</span><br/>
                  <span id="Capacity">${response[i]['Capacity']}</span> <span id="Carrier">${response[i]['Carrier']}</span>
                </div>
              </div>
              <div class="grid__item center">
                <h2 class="h1 dropoff-price" id="Dropoff-Price"><span>$</span>${response[i]['Price']}${response[i]['expireText'] != errorLog(116, "") ? '*': ''}</h2>
                <p class="subtitle--small small-hide" id="Dropoff-Price-Sub-Text">${response[i]['subText']}</p>
              </div>
              <div class="grid__item center">
                ${response[i]['expireText'] != errorLog(116, "") ? `<strong class="expires-txt" id="Expires">${response[i]['expireText']}</strong><br/>`: ''}
                <h2 class="dropoff-date" id="Dropoff-Date">${response[i]['dropOffDate']}</h2>
                <p class="subtitle--small medium-up-hide" id="Dropoff-Price-Sub-Text">${response[i]['subText']}</p>
              </div>
              </div>`
            }
            wrapper.innerHTML = myHTML;
            document.querySelector("#loading").classList.add("hidden")
          } else {
            document.querySelector("#SellingEmpty").classList.remove("hidden")
            document.querySelector("#loading").classList.add("hidden")
            return;
          }
        }
      }
    })
    .catch((e) => {
      document.querySelector("#SellingEmpty").classList.remove("hidden")
      document.querySelector("#loading").classList.add("hidden")
      console.error(e);
    })
  } else {
    window.location.href = "/account/login?session";
  }
}
// END Get selling history in UI

// Get user profile display in UI
if (window.location.href.indexOf("pages/accounts") > -1) {
  const accessToken = getCookie('accessToken');
  if (accessToken) {
    const idToken = getCookie('IdToken');
      if (idToken) {
        const parseIdToken = parseJwt(idToken);
        if (parseIdToken) {
          var countryCode = parseIdToken["custom:country_code"]
        }
      }
      let userEndPoint = `${US_USER_API}`
      if (countryCode != null && countryCode != "" && countryCode != "US") {
        userEndPoint = `${INTL_USER_API}`
      }
    var myHeaders = new Headers();
    myHeaders.append("Authorization", accessToken);
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    }
    fetch(`${userEndPoint}/globaluser/api/v1/user`, requestOptions)
    .then((response) => {
      if(response.status  == 401 || response.status  == 404) {
        document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "IdToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = "/account/login?session";
      } else {
      return  response.json()}
  })
    .then((response) => {
      // if error is present
      if(response.error || response.statusCode) {
        let errCode = '';
        let errMsg = '';
        if (response.error) {
          if (response.statusCode) {
            errCode = response.statusCode;
            errMsg = response.message;
          } else {
            errCode = response.error.serviceCode;
            errMsg = response.error.message;
          }
        }
        let finalErrorMsg = errorLog(errCode, errMsg);
        document.querySelector("#error").innerHTML = finalErrorMsg;
        return;
      } else {
        // if response is 200
        document.querySelector("#Full-Name").innerText = response.firstName + " " + response.lastName;
        document.querySelector("#Account-Name").innerText = response.firstName + " " + response.lastName;
        document.querySelector("#First-Name").innerText = response.firstName;
        document.querySelector("#Last-Name").innerText = response.lastName;
        document.querySelector("#AccountForm-FirstName").value = response.firstName;
        document.querySelector("#AccountForm-LastName").value = response.lastName;
        document.querySelector("#Email").innerText = response.email;
        document.querySelector("#Mobile-Number").innerText = formatPhoneNumber(response.phoneNumber);
        document.querySelector("#AccountForm-phone-number").value = formatPhoneNumber(response.phoneNumber);
        if (response.newsletter == true) {
          document.querySelector("#Newsletter-signup").checked = true;
        } else {
          document.querySelector("#Newsletter-signup").checked = false;
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
  } else {
    window.location.href = "/account/login?session";
  }
}
// END Get user profile display in UI

// Start Update First Name and last name to Cognito
if (window.location.href.indexOf("pages/accounts") > -1) {
  const saveName = document.querySelector("#NameSaveButton");
  if (saveName != null) {
    saveName.addEventListener("click", function(e) {
      const accessToken = getCookie('accessToken');
      if (accessToken) {
        let data ={
          firstName: document.querySelector("#AccountForm-FirstName").value,
          lastName: document.querySelector("#AccountForm-LastName").value,
          email: document.querySelector("#Email").innerText.toLowerCase(),
        }
        var myHeaders = new Headers();
        myHeaders.append("Authorization", accessToken);
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
          method: "PUT",
          mode: 'cors',
          headers: myHeaders,
          body: JSON.stringify(data),
          redirect: 'follow'
        }
        fetch(`${AUTH_API}/globalauth/api/v1/auth/user-attributes`, requestOptions)
        .then((response) => {
          if(response.status  == 401) {
            document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie = "IdToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            window.location.href = "/account/login?session";
          } else {
          return  response.json()}
      })
        .then((response) => {
          // if error is present
          if(response.error || response.statusCode) {
            let errCode = '';
            let errMsg = '';
            if (response.error) {
              if (response.statusCode) {
                errCode = response.statusCode;
                errMsg = response.message;
              } else {
                errCode = response.error.serviceCode;
                errMsg = response.error.message;
              }
            }
            let finalErrorMsg = errorLog(errCode, errMsg);
            return;
          }
        })
        .catch((e) => {
          console.error(e);
        });
      } else {
        window.location.href = "/account/login?session";
      }
    });
  }
}
// End Update First Name and last name to Cognito
if (typeof TogglePassword === "undefined") {
  class TogglePassword extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.togglePassword.bind(this));
    }
    togglePassword() {
      const password = document.querySelector(`#${this.dataset.inputId}`);
      const type = password.getAttribute("type") === "password" ? "text" : "password";
      password.setAttribute("type", type);
      this.classList.toggle("eye-slash");
    }
  }
  customElements.define('toggle-password', TogglePassword);
}
// Start Register Form
if (typeof RegistrationForm === "undefined") {
  class RegistrationForm extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');
      setInterval(() => {
        let accessToken = getCookie("accessToken");
        if(accessToken) {
          window.location.href = "/pages/accounts";
        }
      }, 2000);

      if (!button) return;
      button.addEventListener('click', this.formSubmit.bind(this));
    }
    formSubmit(e) {
      e.preventDefault();
      document.querySelectorAll('.error-message, .g-recaptcha-error').forEach(item => {
        item.classList.add("hidden")
      })
      const data = {
        email: this.querySelector("#RegisterForm-email").value.toLowerCase(),
        password: this.querySelector("#RegisterForm-password").value,
        firstName: this.querySelector("#RegisterForm-FirstName").value,
        lastName: this.querySelector("#RegisterForm-LastName").value,
        phoneNumber: cleanPhoneNumber(this.querySelector("#RegisterForm-phone-number").value),
        newsletter: this.querySelector("#Newsletter-signup").checked,
        newsletterUk: false,
        newsletterFr: false,
        newsletterDe: false
      };

      if (data.email && data.password && data.firstName && data.lastName && data.phoneNumber) {
        if (ENABLE_CAPTCHA) {
          const captchaResponse = grecaptcha.getResponse();
          if(captchaResponse.length == 0) {
            document.querySelector(".g-recaptcha-error").classList.remove("hidden")
            return false;
          }
        }

        if (!ValidateEmail(data.email)) {
          document.querySelector("#error").innerHTML = errorLog(101, "");
          document.querySelector(".error-message").classList.remove("hidden");
          return;
        }
        if (!ValidatePassword(data.password)) {
          document.querySelector("#error").innerHTML = errorLog(102, "");
          document.querySelector(".error-message").classList.remove("hidden");
          return;
        }
        if (!ValidateName(data.firstName)) {
          document.querySelector("#error").innerHTML = errorLog(123, "");
          document.querySelector(".error-message").classList.remove("hidden");
          return;
        }
        if (!ValidateName(data.lastName)) {
          document.querySelector("#error").innerHTML = errorLog(123, "");
          document.querySelector(".error-message").classList.remove("hidden");
          return;
        }
        if (!Validatephonenumber(data.phoneNumber)) {
          document.querySelector("#error").innerHTML = errorLog(103, "");
          document.querySelector(".error-message").classList.remove("hidden");
          return;
        }
        document.querySelectorAll('.registration-form, .title-form, .error-message').forEach(item => {
          item.classList.add("hidden")
        })
        document.querySelector("#loading-text").innerHTML = `${creating_your_account}`
        document.querySelector("#loading").classList.remove("hidden")
        var myHeaders = new Headers();
        myHeaders.append("x-country-code", `${LOCALE}`);
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
          method: "POST",
          mode: 'cors',
          headers: myHeaders,
          body: JSON.stringify(data)
        }
        fetch(`${AUTH_API}/globalauth/api/v1/auth/admin-signup`, requestOptions)
        .then((response) => response.json())
        .then((response) => {
          // if error is present
          if(response.error || response.statusCode) {
            let errCode = '';
            let errMsg = '';
            if (response.error) {
              if (response.statusCode) {
                errCode = response.statusCode;
                errMsg = response.message;
              } else {
                errCode = response.error.serviceCode;
                errMsg = response.error.message;
              }
            }
            let finalErrorMsg = errorLog(errCode, errMsg);
            document.querySelector("#error").innerHTML = finalErrorMsg;
            document.querySelectorAll('.registration-form, .title-form, .error-message').forEach(item => {
              item.classList.remove("hidden")
            })
            document.querySelector("#loading").classList.add("hidden")
            return;
          } else {
            // if response is 200
            let response =  loginCall(data.email, data.password);
            response.then(data);
            return;
          }
        })
        .catch((e) => {
          console.error(e);
          document.querySelector("#loading").classList.add("hidden")
          document.querySelector("#error").innerHTML = errorLog(500, "");
          document.querySelectorAll('.registration-form, .title-form, .error-message').forEach(item => {
            item.classList.remove("hidden")
          })
        })
      } else {
        document.querySelector("#error").innerHTML = errorLog(105, "");
        document.querySelector(".error-message").classList.remove("hidden");
      }
    }
  }
  customElements.define('registration-form', RegistrationForm);
}
// End Register Form

// Start Verify Link
if (window.location.href.indexOf("verifyemail") > -1) {
  document.querySelector(".email-verification-form").classList.remove("hidden");
  document.querySelectorAll('.registration-form, .title-form, .error-message, #loading').forEach(item => {
    item.classList.add("hidden")
  });
}
if (typeof EmailVerification === "undefined") {
  class EmailVerification extends HTMLElement {
    constructor() {
      super();

      const resendLink = this.querySelector(".resend-email-verification a");;
      setInterval(() => {
        let accessToken = getCookie("accessToken");
        if(accessToken) {
          window.location.href = "/pages/accounts";
        }
      }, 2000);

      if (!resendLink) return;
      resendLink.addEventListener('click', (e) => {
        e.preventDefault();
          const data = {
            email: getParameterByName('emailverification')
          };
        if (data.email) {
          document.querySelectorAll('.error-message, .success-message').forEach(item => {
            item.classList.add("hidden")
          })
          let response =  retryVerifyLink(data.email);
          response.then(data)
        } else {
          document.querySelector("#error").innerHTML = errorLog(106, "");
          document.querySelector(".error-message").classList.remove("hidden")
        }
      });
    }
  }
  customElements.define('email-verification-form', EmailVerification);
}
// End Verify Link

// Start Login Form
if (window.location.href.indexOf("updatepassword") > -1) {
  let email = getParameterByName('updatepassword');
  document.querySelector("#success").innerHTML = errorLog(107, "");
  document.querySelector(".success-message").classList.remove("hidden")
  document.getElementById("LoginForm-email").value = email;
}
if (window.location.href.indexOf("accountconfirm") > -1) {
  let email = getParameterByName('accountconfirm');
  document.querySelector("#success").innerHTML = errorLog(109, "");
  document.querySelector(".success-message").classList.remove("hidden")
  document.getElementById("LoginForm-email").value = email;
}
if (window.location.href.indexOf("session") > -1) {
  document.querySelector("#error").innerHTML = errorLog(110, "");
  document.querySelector(".error-message").classList.remove("hidden");
}

if (typeof LoginForm === "undefined") {
  class LoginForm extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');
      setInterval(() => {
        let accessToken = getCookie("accessToken");
        if(accessToken) {
          window.location.href = "/pages/accounts";
        }
      }, 2000);

      if (!button) return;
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('.error-message, .success-message').forEach(item => {
          item.classList.add("hidden")
        })
        const data = {
          email: document.getElementById("LoginForm-email").value.toLowerCase(),
          password: document.getElementById("LoginForm-password").value,
        };

        if (data.email && data.password) {
          if (!ValidateEmail(data.email)) {
            document.querySelector("#error").innerHTML = errorLog(101, "");
            document.querySelector(".error-message").classList.remove("hidden");
            return;
          };
          document.querySelectorAll('.login-form, .title-form, .error-message, .success-message').forEach(item => {
            item.classList.add("hidden")
          })
          document.querySelector("#loading-text").innerHTML = `${logging_in}`
          document.querySelector("#loading").classList.remove("hidden")
         // call login API function
         let response =  loginCall(data.email, data.password);
         response.then(data);
         return;
        } else {
          document.querySelector("#error").innerHTML = errorLog(105, "");
          document.querySelector(".error-message").classList.remove("hidden");
        }
      });
    }
  }
  customElements.define('login-form', LoginForm);
}
// End Login Form

// Start Forgot Password
if (window.location.href.indexOf("forgotpassword") > -1) {
  document.querySelector(".login").classList.add("hidden");
  document.querySelector(".forgot-password").classList.remove("hidden");
}
if (typeof ForgotPasswordForm === "undefined") {
  class ForgotPasswordForm extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');
      setInterval(() => {
        let accessToken = getCookie("accessToken");
        if(accessToken) {
          window.location.href = "/pages/accounts";
        }
      }, 2000);

      if (!button) return;
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const data = {
          email: this.querySelector("#ForgotPasswordForm-email").value.toLowerCase(),
        };

        if (data.email) {
          if (!ValidateEmail(data.email)) {
            document.querySelector(".forgot-password #error").innerHTML = errorLog(101, "");
            document.querySelector(".forgot-password .error-message").classList.remove("hidden")
            return;
          }
          document.querySelectorAll('.forgot-password .forgot-password-form, .forgot-password .title-form, .forgot-password .error-message').forEach(item => {
            item.classList.add("hidden")
          })
          document.querySelector(".forgot-password #loading-text").innerHTML = `${sending_email_text}`
          document.querySelector(".forgot-password #loading").classList.remove("hidden");
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          var requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: myHeaders,
            body: JSON.stringify(data)
          }
          fetch(`${AUTH_API}/globalauth/api/v1/auth/password/forgot`, requestOptions)
          .then((response) => response.json())
          .then((response) => {
            // if error is present
            if(response.error || response.statusCode) {
              let errCode = '';
              let errMsg = '';
              if (response.error) {
                if (response.error.serviceCode == "50004") {
                  let response =  retryVerifyLink(data.email);
                  response.then(data.email)
                  let redirectURL = "/account/register?verifyemail&emailverification="+data.email;
                  window.location.href = redirectURL;
                  return;
                }
                if (response.statusCode) {
                  errCode = response.statusCode;
                  errMsg = response.message;
                } else {
                  errCode = response.error.serviceCode;
                  errMsg = response.error.message;
                }
              }
              let finalErrorMsg = errorLog(errCode, errMsg);
              document.querySelector(".forgot-password #loading").classList.add("hidden");

              if (finalErrorMsg == errorLog(50016, "")) {
                finalErrorMsg = errorLog(115, "")
              }
              document.querySelector(".forgot-password #error").innerHTML = finalErrorMsg;
              document.querySelectorAll('.forgot-password .forgot-password-form, .forgot-password .title-form, .forgot-password .error-message').forEach(item => {
                item.classList.remove("hidden")
              })
              return;
            } else {
              // if response is 200
              window.location.href = "/account/login?resetpassword="+data.email;
            }
          })
          .catch((e) => {
            console.error(e);
            document.querySelector(".forgot-password #loading").classList.add("hidden");
            document.querySelector(".forgot-password #error").innerHTML = errorLog(500, "");
            document.querySelectorAll('.forgot-password .forgot-password-form, .forgot-password .title-form, .forgot-password .error-message').forEach(item => {
              item.classList.remove("hidden")
            })
          });
        } else {
          document.querySelector(".forgot-password #error").innerHTML = errorLog(105, "");
          document.querySelector(".forgot-password .error-message").classList.remove("hidden")
        }
      });
    }
  }
  customElements.define('forgot-password-form', ForgotPasswordForm);
}
// End Forgot Password

// Start Reset Password with Confirmation Code
if (window.location.href.indexOf("resetpassword") > -1) {
  document.querySelector(".login").classList.add("hidden");
  document.querySelector(".reset-password").classList.remove("hidden");
  let email = getParameterByName('resetpassword');
  document.querySelector("#ResetPasswordForm-email").value = email;
}
if (typeof ResetPasswordForm === "undefined") {
class ResetPasswordForm extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    setInterval(() => {
      let accessToken = getCookie("accessToken");
      if(accessToken) {
        window.location.href = "/pages/accounts";
      }
    }, 2000);

    if (!button) return;
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const data = {
        email: document.querySelector("#ResetPasswordForm-email").value.toLowerCase(),
        password: document.querySelector("#ResetPasswordForm-password").value,
        confirmationCode: document.querySelector("#ResetPasswordForm-confirmcode").value
      };

      if (data.email && data.password && data.confirmationCode) {
        if (!ValidateEmail(data.email)) {
          document.querySelector(".reset-password #error").innerHTML = errorLog(101, "");
          document.querySelector(".reset-password .error-message").classList.remove("hidden");
          return;
        }
        if (!ValidatePassword(data.password)) {
          document.querySelector(".reset-password #error").innerHTML = errorLog(102, "");
          document.querySelector(".reset-password .error-message").classList.remove("hidden");
          return;
        }
        document.querySelectorAll('.reset-password reset-password-form, .reset-password .title-form, .reset-password .error-message, .reset-password .success-message').forEach(item => {
          item.classList.add("hidden")
        })
        document.querySelector(".reset-password #loading-text").innerHTML = `${updating_password}`
        document.querySelector(".reset-password #loading").classList.remove("hidden")
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
          method: "POST",
          mode: 'cors',
          headers: myHeaders,
          body: JSON.stringify(data)
        }
        fetch(`${AUTH_API}/globalauth/api/v1/auth/password/confirm`, requestOptions)
        .then((response) => response.json())
        .then((response) => {
          // if error is present
          if(response.error || response.statusCode) {
            let errCode = '';
            let errMsg = '';
            if (response.error) {
              if (response.statusCode) {
                errCode = response.statusCode;
                errMsg = response.message;
              } else {
                errCode = response.error.serviceCode;
                errMsg = response.error.message;
              }
            }
            let finalErrorMsg = errorLog(errCode, errMsg);
            document.querySelector(".reset-password #loading").classList.add("hidden")
            document.querySelector(".reset-password #error").innerHTML = finalErrorMsg;
            document.querySelectorAll('.reset-password reset-password-form, .reset-password .title-form, .reset-password .error-message').forEach(item => {
              item.classList.remove("hidden")
            })
            return;
          } else {
            // if response is 200
            // document.querySelector(".reset-password #loading").classList.add("hidden")
            window.location.href = `/account/login?updatepassword=${data.email}`;
          }
        })
        .catch((e) => {
          console.error(e);
          document.querySelector(".reset-password #loading").classList.add("hidden")
          document.querySelector(".reset-password #error").innerHTML = errorLog(500, "");
          document.querySelectorAll('.reset-password reset-password-form, .reset-password .title-form, .reset-password .error-message').forEach(item => {
            item.classList.remove("hidden")
          })
        });
      } else {
        document.querySelector(".reset-password #error").innerHTML = errorLog(105, "");
        document.querySelector(".reset-password .error-message").classList.remove("hidden")
      }
    });
  }
}
customElements.define('reset-password-form', ResetPasswordForm);
}
// End Reset Password with Confirmation Code

// Start Resend Code Link in reset password page
if (typeof ResendCodeVerification === "undefined") {
class ResendCodeVerification extends HTMLElement {
  constructor() {
    super();

    const resendLink = this.querySelector(".resend-code a");
    setInterval(() => {
      let accessToken = getCookie("accessToken");
      if(accessToken) {
        window.location.href = "/pages/accounts";
      }
    }, 2000);

    if (!resendLink) return;
    resendLink.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelectorAll('.reset-password .error-message, .reset-password .success-message').forEach(item => {
        item.classList.add("hidden")
      })
      const resendEmail =  getParameterByName('resetpassword');
        const data = {
          email: resendEmail
        };
      if (data.email) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
          method: "POST",
          mode: 'cors',
          headers: myHeaders,
          body: JSON.stringify(data)
        }
        fetch(`${AUTH_API}/globalauth/api/v1/auth/password/forgot`, requestOptions)
        .then((response) => response.json())
        .then((response) => {
          // if error is present
          if (response.error || response.statusCode) {
            let errCode = '';
            let errMsg = '';
            if (response.error) {
              if (response.statusCode) {
                errCode = response.statusCode;
                errMsg = response.message;
              } else {
                errCode = response.error.serviceCode;
                errMsg = response.error.message;
              }
            }
            let finalErrorMsg = errorLog(errCode, errMsg);
            document.querySelector(".reset-password #error").innerHTML = finalErrorMsg;
            document.querySelector(".reset-password .error-message").classList.remove("hidden")
            return;
          } else {
            // if response is 200
            document.querySelector(".reset-password #success").innerHTML = errorLog(108, "") + data.email;
            document.querySelector(".reset-password .success-message").classList.remove("hidden")
          }
        })
        .catch((e) => {
        console.error(e);
        document.querySelector(".reset-password #error").innerHTML =  errorLog(500, "");
        document.querySelector(".reset-password .error-message").classList.remove("hidden")
        });
      } else {
        document.querySelector(".reset-password #error").innerHTML = errorLog(106, "");
        document.querySelector(".reset-password .error-message").classList.remove("hidden")
      }
    });
  }
}
customElements.define('resend-code-form', ResendCodeVerification);
}
// End Resend Code Link in reset password page

// signout or Logout
class SignOut extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('#SignOut');
    button.addEventListener('click', this.signout.bind(this));
  }
  signout(e) {
    e.preventDefault();
    document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "IdToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    location.href="/account/login";
  }
}
customElements.define('sign-out', SignOut);
// END signout or Logout

// START Update Name Form
if (typeof NameForm === "undefined") {
class NameForm extends HTMLElement {
  constructor() {
    super();
    const editButton = this.querySelector('.btn-edit');
    const cancelButton = this.querySelector('.btn-cancel');
    const saveButton = this.querySelector('.btn-save');
    editButton.addEventListener('click', this.edit.bind(this));
    cancelButton.addEventListener('click', this.cancel.bind(this));
    saveButton.addEventListener('click', this.save.bind(this));
  }
  edit(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Name .error-message, #Setting-Name .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    this.querySelector(".full-name").classList.add("hidden");
    this.querySelector("form").classList.remove("hidden");
  }
  save(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Name .error-message, #Setting-Name .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    let data = {
      firstName: this.querySelector("#AccountForm-FirstName").value,
      lastName: this.querySelector("#AccountForm-LastName").value,
      email: document.querySelector("#Email").innerText,
      phoneNumber: cleanPhoneNumber(document.querySelector("#AccountForm-phone-number").value)
    }
    if (data.firstName == null || data.firstName == "") {
      document.querySelector("#error").innerHTML = errorLog(105, "");
      document.querySelector(".error-message").classList.remove("hidden");
      return;
    }
    if (data.lastName == null || data.lastName == "") {
      document.querySelector("#error").innerHTML = errorLog(105, "");
      document.querySelector(".error-message").classList.remove("hidden");
      return;
    }
    if (!ValidateName(data.firstName)) {
      document.querySelector("#error").innerHTML = errorLog(123, "");
      document.querySelector(".error-message").classList.remove("hidden");
      return;
    }
    if (!ValidateName(data.lastName)) {
      document.querySelector("#error").innerHTML = errorLog(123, "");
      document.querySelector(".error-message").classList.remove("hidden");
      return;
    }
    let nameForm = "nameForm"
    let response =  updateProfile(data, nameForm);
    response.then(data)
    this.querySelector("form").classList.add("hidden");
    this.querySelector(".full-name").classList.remove("hidden");
  }
  cancel(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Name .error-message, #Setting-Name .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    document.querySelector("#AccountForm-FirstName").value = document.querySelector("#First-Name").innerText
    document.querySelector("#AccountForm-LastName").value = document.querySelector("#Last-Name").innerText
    this.querySelector("form").classList.add("hidden");
    this.querySelector(".full-name").classList.remove("hidden");
  }
}
customElements.define('name-form', NameForm);
}
// END Update Name Form

// START Update Phone Form
if (typeof PhoneForm === "undefined") {
class PhoneForm extends HTMLElement {
  constructor() {
    super();
    const editButton = this.querySelector('.btn-edit');
    const cancelButton = this.querySelector('.btn-cancel');
    const saveButton = this.querySelector('.btn-save');
    editButton.addEventListener('click', this.edit.bind(this));
    cancelButton.addEventListener('click', this.cancel.bind(this));
    saveButton.addEventListener('click', this.save.bind(this));
  }
  edit(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Mobile-Number .error-message, #Setting-Mobile-Number .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    this.querySelector(".phone-number").classList.add("hidden");
    this.querySelector("form").classList.remove("hidden");
  }
  save(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Mobile-Number .error-message, #Setting-Mobile-Number .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    let data = {
      firstName: document.querySelector("#AccountForm-FirstName").value,
      lastName: document.querySelector("#AccountForm-LastName").value,
      email: document.querySelector("#Email").innerText,
      phoneNumber: cleanPhoneNumber(this.querySelector("#AccountForm-phone-number").value)
    }
    if (!Validatephonenumber(data.phoneNumber)) {
      document.querySelector("#Setting-Mobile-Number #error").innerHTML = errorLog(103, "");
      document.querySelector("#Setting-Mobile-Number .error-message").classList.remove("hidden");
      return;
    }
    let mobileForm = "mobileForm"
    let response =  updateProfile(data, mobileForm);
    response.then(data)
    this.querySelector("form").classList.add("hidden");
    this.querySelector(".phone-number").classList.remove("hidden");
  }
  cancel(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Mobile-Number .error-message, #Setting-Mobile-Number .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    document.querySelector("#AccountForm-phone-number").value = formatPhoneNumber(document.querySelector("#Mobile-Number").innerHTML)
    this.querySelector("form").classList.add("hidden");
    this.querySelector(".phone-number").classList.remove("hidden");
  }
}
customElements.define('phone-form', PhoneForm);
}
// END Update Phone Form

// START User logged in update password form
if (typeof UserUpdatePasswordForm === "undefined") {
class UserUpdatePasswordForm extends HTMLElement {
  constructor() {
    super();
    const editButton = this.querySelector('.btn-edit');
    const cancelButton = this.querySelector('.btn-cancel');
    const saveButton = this.querySelector('.btn-save');
    editButton.addEventListener('click', this.edit.bind(this));
    cancelButton.addEventListener('click', this.cancel.bind(this));
    saveButton.addEventListener('click', this.save.bind(this));
  }
  edit(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Password .error-message, #Setting-Password .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    this.querySelector(".password-edit").classList.add("hidden");
    this.querySelector("form").classList.remove("hidden");
  }
  save(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Password .error-message, #Setting-Password .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    const accessToken = getCookie('accessToken');
    if (accessToken) {
      const email = document.querySelector("#Email").innerText
      let data = {
        previousPassword: this.querySelector("#AccountForm-CurrentPassword").value,
        proposedPassword: this.querySelector("#AccountForm-NewPassword").value
      }
    if (data.previousPassword && data.proposedPassword) {
      if (!ValidatePassword(data.proposedPassword)) {
        document.querySelector("#Setting-Password #error").innerHTML = errorLog(113, "");
        document.querySelector("#Setting-Password .error-message").classList.remove("hidden");
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", accessToken);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "POST",
        mode: 'cors',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      }
      fetch(`${AUTH_API}/globalauth/api/v1/auth/change-password`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        // if error is present
        if(response.error || response.statusCode) {
          let errCode = '';
          let errMsg = '';
          if (response.error) {
            if (response.statusCode) {
              if (response.message == "Incorrect username or password.") {
                document.querySelector("#Setting-Password #error").innerHTML = errorLog(122, "");;
                document.querySelector('#Setting-Password .error-message').classList.remove("hidden")
                return;
              }
              errCode = response.statusCode;
              errMsg = response.message;
            } else {
              errCode = response.error.serviceCode;
              errMsg = response.error.message;
            }
          }
          let finalErrorMsg = errorLog(errCode, errMsg);
          document.querySelector("#Setting-Password #error").innerHTML = finalErrorMsg;
          document.querySelector('#Setting-Password .error-message').classList.remove("hidden")
          return;
        } else {
          // if response is 200
          document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          document.cookie = `IdToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          window.location.href = `/account/login?updatepassword=${email}`;
        }
      })
      .catch((e) => {
        console.error(e);
      });
    } else {
      document.querySelector("#Setting-Password #error").innerHTML = errorLog(105, "");
      document.querySelector("#Setting-Password .error-message").classList.remove("hidden");
    }
    } else {
      window.location.href = "/account/login?session";
    }
  }
  cancel(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Password .error-message, #Setting-Password .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    this.querySelector("#AccountForm-CurrentPassword").value = "";
    this.querySelector("#AccountForm-NewPassword").value = "";
    this.querySelector("form").classList.add("hidden");
    this.querySelector(".password-edit").classList.remove("hidden");
  }
}
customElements.define('user-update-password-form', UserUpdatePasswordForm);
}
// END User logged in update password form

// START user logeed in update notification form
if (typeof NotificationForm === "undefined") {
class NotificationForm extends HTMLElement {
  constructor() {
    super();
    const saveButton = this.querySelector('#Newsletter-signup');
    saveButton.addEventListener('click', this.save.bind(this));
  }
  save(e) {
    e.preventDefault();
    document.querySelectorAll('#Setting-Notification .error-message, #Setting-Notification .success-message').forEach(item => {
      item.classList.add("hidden")
    })
    const accessToken = getCookie('accessToken');
    if (accessToken) {
      let data = {
        newsletter: this.querySelector("#Newsletter-signup").checked,
        email: document.querySelector("#Email").innerText,
        countryCode: `${LOCALE}`,
        firstName: document.querySelector("#AccountForm-FirstName").value,
        lastName: document.querySelector("#AccountForm-LastName").value
      }
    if (data) {
      const idToken = getCookie('IdToken');
      if (idToken) {
        const parseIdToken = parseJwt(idToken);
        if (parseIdToken) {
          var countryCode = parseIdToken["custom:country_code"]
        }
      }
      let userEndPoint = `${US_USER_API}`
      if (countryCode != null && countryCode != "" && countryCode != "US") {
        userEndPoint = `${INTL_USER_API}`
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", accessToken);
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "PUT",
        mode: 'cors',
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      }
      fetch(`${userEndPoint}/globaluser/api/v1/user/newsletter`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        // if error is present
        if(response.error || response.statusCode) {
          let errCode = '';
          let errMsg = '';
          if (response.error) {
            if (response.statusCode) {
              errCode = response.statusCode;
              errMsg = response.message;
            } else {
              errCode = response.error.serviceCode;
              errMsg = response.error.message;
            }
          }
          let finalErrorMsg = errorLog(errCode, errMsg);
          document.querySelector("#Setting-Notification #error").innerHTML = finalErrorMsg;
          document.querySelector('#Setting-Notification .error-message').classList.remove("hidden")
          return;
        } else {
          // if response is 200
          if (response.Attributes.newsletter == true) {
            document.querySelector("#Newsletter-signup").checked = true;
          } else {
            document.querySelector("#Newsletter-signup").checked = false;
          }
          document.querySelector("#Setting-Notification #success").innerHTML = errorLog(112, "");
          document.querySelector("#Setting-Notification .success-message").classList.remove("hidden");
        }
      })
      .catch((e) => {
        console.error(e);
      });
    } else {
      document.querySelector("#Setting-Notification #error").innerHTML = errorLog(105, "");
      document.querySelector("#Setting-Notification .error-message").classList.remove("hidden");
    }
    } else {
      window.location.href = "/account/login?session";
    }
  }
}
customElements.define('notification-form', NotificationForm);
}
// END user logeed in update notification form


// START Delete/signout account
if (typeof DeleteAccountForm === "undefined") {
class DeleteAccountForm extends HTMLElement {
  constructor() {
    super();
    const deleteButton = this.querySelector('#Delete-Button');
    const cancelButton = this.querySelector('#Cancel-Button');
    deleteButton.addEventListener('click', this.delete.bind(this));
    cancelButton.addEventListener('click', this.cancel.bind(this));
  }
  delete(e) {
    e.preventDefault();
    const accessToken = getCookie('accessToken');
    if (accessToken) {
      const idToken = getCookie('IdToken');
      if (idToken) {
        const parseIdToken = parseJwt(idToken);
        if (parseIdToken) {
          var countryCode = parseIdToken["custom:country_code"]
        }
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", accessToken);
      myHeaders.append("x-country-code", countryCode);
      var requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: 'follow'
      }
      fetch(`${AUTH_API}/globalauth/api/v1/auth/user`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        // if error is present
        if(response.error || response.statusCode) {
          let errCode = '';
          let errMsg = '';
          if (response.error) {
            if (response.statusCode) {
              errCode = response.statusCode;
              errMsg = response.message;
            } else {
              errCode = response.error.serviceCode;
              errMsg = response.error.message;
            }
          }
          let finalErrorMsg = errorLog(errCode, errMsg);
          document.querySelector("#error").innerHTML = finalErrorMsg;
          document.querySelector(".error-message").classList.remove("hidden");
          return;
        } else {
          // if response is 200
          document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          document.cookie = `IdToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          document.querySelector('.delete-account-submit').classList.add("hidden")
          document.querySelector('.delete-account-confirm').classList.remove("hidden")
        }
      })
      .catch((e) => {
        console.error(e);
      });
    } else {
      window.location.href = "/account/login?session";
    }
  }
  cancel(e) {
    e.preventDefault();
    let redirectURL = "/pages/accounts?account-details";
    window.location.href = redirectURL;

  }
}
customElements.define('delete-account-form', DeleteAccountForm);
}
// END Delete/signout account

// START Account Verify with email and code
if (window.location.href.indexOf("/account/register?accountverify?") > -1) {
    document.querySelectorAll('.registration-form, .title-form, .error-message').forEach(item => {
      item.classList.add("hidden")
    document.querySelector("#loading-text").innerHTML = `${verifying_your_account}`
    document.querySelector("#loading").classList.remove("hidden")
  })

  const data = {
    email: getParameterByName('emailverification'),
    confirmationCode: getParameterByName('code')
  };
  if (data.email && data.confirmationCode) {
    let isMobile = window.matchMedia("(any-pointer:coarse)").matches;
    let source = ""
    if (window.location.href.indexOf("&source") > -1) {
      source = getParameterByName('source')
    }
    if (isMobile && (source == "ios" || source == "android")) {
      window.location.href = `${MOBILE_API}?emailverification=${data.email}&code=${data.confirmationCode}`
    } else {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
        redirect: 'follow'
      }
      fetch(`${AUTH_API}/globalauth/api/v1/auth/signup/confirm`, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        // if error is present
        if(response.error || response.statusCode) {
          let errCode = '';
          let errMsg = '';
          if (response.error) {
            if (response.statusCode) {
              errCode = response.statusCode;
              errMsg = response.message;
            } else {
              errCode = response.error.serviceCode;
              errMsg = response.error.message;
              if (errCode == 50017) {
                window.location.href = `/account/login?accountconfirm=${data.email}`;
                return;
              }
            }
          }
          let finalErrorMsg = errorLog(errCode, errMsg);
          document.querySelector("#error").innerHTML = finalErrorMsg;
          document.querySelectorAll('.email-verification-form, .error-message').forEach(item => {
            item.classList.remove("hidden");
          document.querySelector("#loading").classList.add("hidden")
      })
          return;
        } else {
          // if response is 200
          window.location.href = `/account/login?accountconfirm=${data.email}`;
        }
      })
      .catch((e) => {
        console.error(e);
      });
    }
  } else {
    document.querySelector("#error").innerHTML = errorLog(106, "");
    document.querySelectorAll('.email-verification-form, .error-message').forEach(item => {
      item.classList.remove("hidden");
      document.querySelector("#loading").classList.add("hidden")
    })
  }
}
// END Account Verify with email and code

const field = document.querySelector('input[type="tel"]');
if (field != null) {
  field.onkeypress =  function(e) {
	let keyVal = String.fromCharCode(e.keyCode);
	let filteredValue = this.value.replace(/\D/g,'');

	if ( filteredValue.length > 0 ) {
			field.value = filteredValue.replace(/(\d{3})/, "($1) ");
	}

	if ( filteredValue.length > 5 ) {
		field.value = filteredValue.replace(/(\d{3})(\d{3})/, "($1) $2-");
	}

	return ( isNumber(keyVal) && filteredValue.length <= 9 )
};
}


// Validate Numeric inputs
function isNumber(o) {
    return o == '' || !isNaN(o - 0);
}